export const teamsApi = (client) => ({
    list: (params) => client.get('/api/v1/teams', { params }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/teams/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/teams', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/teams/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/teams/${id}`).then((r) => r.data),
    uploadAvatar: (id, file) => {
        const form = new FormData();
        form.append('file', file);
        return client.post(`/api/v1/teams/${id}/avatar`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((r) => r.data);
    },
    deleteAvatar: (id) => client.delete(`/api/v1/teams/${id}/avatar`).then((r) => r.data),
    listMembers: (id) => client.get(`/api/v1/teams/${id}/members`).then((r) => r.data),
    addMembers: (id, user_ids) => client.post(`/api/v1/teams/${id}/members`, { user_ids }).then((r) => r.data),
    removeMember: (id, userId) => client.delete(`/api/v1/teams/${id}/members/${userId}`).then((r) => r.data),
});
//# sourceMappingURL=teams.js.map